<template>
  <div>
    <div class="kt-login-v2__title">
      <h3>Wachtwoord vergeten</h3>
    </div>

    <form
      id="kt_login_form"
      class="kt-login-v2__form kt-form"
      @submit.prevent
    >
      <div class="form-group">
        <input-text
          id="email"
          v-model="email"
          type="email"
          name="email"
          title="e-mailadres"
          class="form-control height-unset pl-3"
          autocomplete="none"
          placeholder="E-mailadres"
        />
      </div>

      <div class="kt-login-v2__actions mt-2">
        <a
          class="kt-link kt-login-v2__link cursor-pointer"
          @click="page = AuthPage.LOGIN"
        >
          Inloggen
        </a>

        <button
          type="submit"
          class="btn btn--primary"
          :disabled="!email"
          @click="submit"
        >
          Wijzig wachtwoord
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { AuthPage, useAuthStore } from '@/stores/auth'
import InputText from '@/components/input/InputText.vue'

const authStore = useAuthStore()

const {
  email,
  page,
  hasValidationError,
  requestMessage
} = storeToRefs(authStore)

const submit = async () => {
  if (!email.value) return

  hasValidationError.value = false

  try {
    const response = await authStore.forgotPassword()

    requestMessage.value = response.data?.message ?? 'Er is een e-mail verstuurd met instructies om je wachtwoord te wijzigen.'
    page.value = AuthPage.LOGIN
  } catch (e) {
    if (e?.response?.status === 422) {
      requestMessage.value = 'Er is iets misgegaan bij het wijzigen van je wachtwoord. Probeer het later nog eens.'
      hasValidationError.value = true
      page.value = AuthPage.LOGIN

      return
    }

    console.error(e)
  }
}
</script>

<style scoped lang="scss">
.height-unset {
  height: unset;
}
</style>
